const Tooltips = {
      nodeTypeDescription: {
        text: "The Node dropdown shows the nodes in Technopedia that are available for your selection. Technopedia is a graph database and is built using nodes and relationships. A node represents a 'thing' such as a software release, a manufacturer or a CPU. Each node has certain attributes or properties which you can use to filter your search. Click the Add Attribute button to see which attributes are available for your selected node and refine your search."
      },
      relationshipDescription: {
        text: "The Relationship dropdown enables you to select one of the supported relationships available in Technopedia. The available relationships will change based on the first node you select. In a graph database, nodes are connected via relationships. Selecting a relationship will enable you to return nodes that are connected by that relationship. For example, a 'Manufacturer' (node) is a 'Vendor Of' (relationship) 'Software' (node)."
      },
      attributeDescription: {
        text: "By default, all of the attributes are returned for each node in a search. The Return dropdown shows all of the attributes available for the Nodes you have selected and allows you to choose which attributes are returned in your search. For example, you can choose to see the Title and End of Life attributes for the Software assets 'Acrobat' and 'Photoshop'. If you do not choose a particular attribute, it will return all of the attributes."
      },
      software: [
        {
          name: 'Title',
          text: 'The name of the software product.'
        },
        {
          name: 'Version',
          text: 'The software product\'s version name or number as listed by the manufacturer.'
        },
        {
          name: 'Version Group',
          text: 'The grouping of one or more versions using the better-known "market version" name or number.'
        },
        {
          name: 'Edition',
          text: 'The software product\'s edition name, when applicable.'
        },
        {
          name: 'Category',
          text: 'The deepest level category for this product within the BDNA Taxonomy system.'
        }
      ],
      hardware: [
        {
          name: 'Title',
          text: 'The name of the hardware product, which generally captures the product line/series, product family, and/or generation.'
        },
        {
          name: 'Model',
          text: 'The hardware product\'s model name/number, which captures multiple variations under the product line.'
        },
        {
          name: 'Profile',
          text: 'The profile or the form factor of the hardware model.'
        },
        {
          name: 'Category',
          text: 'The deepest level category for this product within the BDNA Taxonomy system.'
        }
      ],
      cpu: [
      {
        name: 'Model',
        text: 'The model name of the CPU, which captures model number, speed/clock rate, and code name, if applicable.'
      },
      {
        name: 'Core',
        text: 'The number of cores per CPU chip.'
      },
      {
        name: 'Clock Rate',
        text: 'The clock speed or frequency at which the CPU is running (in MHz).'
      }
    ]
  }

  export default Tooltips;



// WEBPACK FOOTER //
// ./src/config/Tooltips.js